import { render, staticRenderFns } from "./interfacemaintenance.vue?vue&type=template&id=fbad1fc8&"
import script from "./interfacemaintenance.vue?vue&type=script&lang=js&"
export * from "./interfacemaintenance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports